/**
 * Unload stores or domains no longer associated with the company but failed to remove the script from their site.
 * Use store ID or domain to blacklist a store.
 */
const Blacklist = [
  {
    storeId: '188',
    domain: 'grapevinedodge.com',
  },
];

/**
 * Assert if the current site identified by the domain or container store ID
 * attribute is blacklisted
 */
export const checkBlacklisted = (siteStoreId?: string) => {
  for (const blackListItem of Blacklist) {
    const { storeId, domain } = blackListItem;

    // Check domain or store id if matches blacklist
    return window.location.origin.includes(domain) || storeId === siteStoreId;
  }

  return false;
};
